// extracted by mini-css-extract-plugin
module.exports = {"errorBoundary":"ErrorBoundary_errorBoundary__vP7XV"};